export const DROPDOWN_KEY = 'portfolios'
export const BUTTONSARRAY_KEY = 'portfolioBlocks'

export const PORTFOLIO_RIBBON_CHANGE_EVENT = 'PORTFOLIO_RIBBON_CHANGE_EVENT'
